<template>
  <div class="information-tab">
    <div class="information-block">
      <div class="information-block__title">Помещение</div>

      <div class="information-block__about">
        <div class="ibi-point">
          <div class="ibi-point__name">Адрес объекта</div>
          <div class="ibi-point__info">{{ item.address }}</div>
        </div>
        <div class="ibi-point">
          <div class="ibi-point__name">Размер дома/ помещения</div>
          <div class="ibi-point__info">{{ item.house_size }}</div>
        </div>
        <div class="ibi-point">
          <div class="ibi-point__name">Технические характеристики</div>
          <div class="ibi-point__info">{{ item.technical_specifications }}</div>
        </div>
      </div>
    </div>

    <div class="information-block">
      <div class="information-block__title">Информация по проекту</div>
      <div class="information-block__about">
        <div class="ibi-point">
          <div class="ibi-point__name">Виды работ</div>
          <div class="ibi-point__info">{{ item.types_work }}</div>
        </div>
        <div class="ibi-point">
          <div class="ibi-point__name">Архитектурные планы</div>
          <div class="ibi-point__info" v-if="item.architectural_plans.length">
            <a
              class="architectural-plan-link"
              v-for="(item2, index) in item.architectural_plans"
              :key="index"
              :href="item.architectural_plans[index].url"
              target="_blank"
            >
              <v-icon color="#0464AC">mdi-file-outline</v-icon>
              {{ item.architectural_plans[index].name }}
            </a>
          </div>
        </div>
        <div class="ibi-point">
          <div class="ibi-point__name">Разделы инженерных сетей</div>
          <div class="ibi-point__info">{{ item.question_1 }}</div>
        </div>
        <div class="ibi-point">
          <div class="ibi-point__name">Этап строительства объекта</div>
          <div class="ibi-point__info">{{ item.question_2_title }}</div>
        </div>
      </div>
    </div>

    <div class="information-block">
      <div class="information-block__title">Оборудование</div>
      <div class="information-block__about">
        <div class="ibi-point">
          <div class="ibi-point__name">Наличие оборудования</div>
          <div class="ibi-point__info">{{ item.question_3_title }}</div>
        </div>
        <div class="ibi-point">
          <div class="ibi-point__name">Пожелания к оборудованию</div>
          <div class="ibi-point__info">{{ item.question_4 }}
          </div>
        </div>
      </div>
    </div>

    <div class="information-block">
      <div class="information-block__title">Чек за покупку оборудования</div>
      <div class="information-block__about">
        <div class="ibi-point">
          <div class="ibi-point__name">Фото чека</div>
          <div class="ibi-point__info" v-if="item.check.length">
            <a
              class="check-link"
              v-for="(item2, index) in item.check"
              :key="index"
              :href="item.check[index].url"
              target="_blank"
            >
              <v-icon color="#0464AC">mdi-file-outline</v-icon>
              {{ item.check[index].name }}
            </a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: 'Information',

  props: {
    item: Object,
  },
  data() {
    return {
      photoCheck: false,
      photoCheckPlan: false,
    };
  },
};
</script>
<style>
.architectural-plan-link, .check-link {
  margin-right: 20px;
  text-decoration: none;
}
</style>
